<section>
    <div><app-header></app-header></div>
<div class="mainFrame">
<div class="centerMain">
    <div class="leftFrame">
        <div class="topLeftFrame"><button class="link" onclick="window.location.href='https://www.linkedin.com/in/michael-spari-3541a3351'"><img class="linkin" src="assets/icon/hero/socialMedia/linkin.png"></button></div>
        <div class="middleLeftFrame"><button class="git" onclick="window.location.href='https://github.com/Michael-Spari'"><img class="linkin" src="assets/icon/hero/socialMedia/github.png"></button></div> 
        <div class="bottomLeftFrame"><button class="mail" onclick="window.location.href='mailto:info@michaelspari.de'"><img class="linkin" src="assets/icon/hero/socialMedia/mail.png"></button></div>
    </div>
    <div class="placeholder"></div>
    <div class="masterContainerFrame">
    
    <div class="container">
        <div class="rowTop">
            <div class="rowTopLeft">
                    <div class="wavingHandDiv">
                        <button class="btnAnimation" onmouseover="this.innerHTML='I`M MICHAEL SPARI'" onmouseout="this.innerHTML='Hello world'">Hello world</button>
                        <div class="gitCat"><img src="assets/icon/hero/heWo/waving_hand.png"></div>
                    </div>
                    <div class="rowTopLeftBottom">
                        <p class="animationText">
                            <span class="hover-char" appHighlight>F</span>
                            <span class="hover-char" appHighlight>r</span>
                            <span class="hover-char" appHighlight>o</span>
                            <span class="hover-char" appHighlight>n</span>
                            <span class="hover-char" appHighlight>t</span>
                            <span class="hover-char" appHighlight>e</span>
                            <span class="hover-char" appHighlight>n</span>
                            <span class="hover-char" appHighlight>d</span>
                          </p>
                    </div>
                </div>
                <div class="rowTopRight">
                    <img class="imageMe" src="assets/icon/hero/profil/Group-34.png" alt="hero-image">
                </div>
            </div>
            <div class="rowBottom">
                <div class="rowBottomTop">
                    <p class="animationText">
                        <span class="hover-char" appHighlight>D</span>
                        <span class="hover-char" appHighlight>E</span>
                        <span class="hover-char" appHighlight>V</span>
                        <span class="hover-char" appHighlight>E</span>
                        <span class="hover-char" appHighlight>L</span>
                        <span class="hover-char" appHighlight>O</span>
                        <span class="hover-char" appHighlight>P</span>
                        <span class="hover-char" appHighlight>E</span>
                        <span class="hover-char" appHighlight>R</span>
                    </p>
                </div>
                <div class="rowBottomBottom"><button onclick="window.location.href='mailto:info@michaelspari.de'" class="getInTouch">{{ 'about-the-fold.button' | translate }}</button></div>
            </div>
            <div class="imageMeFrame">
                <img class="imageMe" src="assets/icon/hero/profil/Group-34.png" alt="hero-image">
            </div>
        </div>
        <div class="placeholder"></div>
    </div>
</div>
</div>
</section>

